import { InAppMessageEligibilityEvaluation } from "../../../core/internal/evaluation/service/inappmessage/eligibility/InAppMessageEligibilityEvaluation"
import UserEvent, { TrackEvent } from "../../../core/internal/event/UserEvent"
import { InAppMessage, HackleUser } from "../../../core/internal/model/model"
import Workspace from "../../../core/internal/workspace/Workspace"
import { InAppMessageEventMatcher } from "./InAppMessageEventMatcher"
import { InAppMessageTrigger } from "./InAppMessageTrigger"

export interface InAppMessageTriggerDeterminer {
  determine(event: UserEvent): InAppMessageTrigger | null
}

export abstract class AbstractInAppMessageTriggerDeterminer<W extends Workspace, M extends InAppMessage>
  implements InAppMessageTriggerDeterminer
{
  protected abstract eventMatcher: InAppMessageEventMatcher

  protected abstract workspace(user: HackleUser): W | null

  protected abstract evaluate(workspace: W, message: M, event: TrackEvent): InAppMessageEligibilityEvaluation

  determine(event: UserEvent): InAppMessageTrigger | null {
    const trackEvent = UserEvent.isTrackEvent(event) ? event : null
    if (!trackEvent) return null

    const workspace = this.workspace(trackEvent.user)
    if (!workspace) return null

    for (const message of workspace.getInAppMessages()) {
      const matches = this.eventMatcher.matches(workspace, message, trackEvent)
      if (!matches) {
        continue
      }

      // `W` fixes the concrete in-app message type, so this narrowing to `M` is safe.
      const evaluation = this.evaluate(workspace, message as M, trackEvent)
      if (evaluation.isEligible) {
        return new InAppMessageTrigger(message, evaluation.result.reason, trackEvent)
      }
    }

    return null
  }
}
